import React from "react";
import {  Col, FormLabel, Row, } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleBean,
  FabricStyleSearchCriteria,
  ProductAvailabilityCriteriaBean,
  ProductAvailabilityDetailsRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupFabricStyleModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class ProductAvailability extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Product Availability Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new ProductAvailabilityCriteriaBean(),
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      moduleForPopup: [],
      atsInfosList: [],
      availabilityInfoList: [],
      purchaseProductAvailabilityList: [],
      salesProductAvailabilityList: [],
      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowLookUp: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
      is3PL: false,
    };
    this.fabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (isEmptyString(criteria.fabricStyleCode)) {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "FabricCode is Required";
      } else {
        errMsg = "ItemCode is Required";
      }
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: " ",
      });
    } else {
      this.loadProductAvailabilityInquiryList(criteria);
    }
  };
  loadProductAvailabilityInquiryList = (criteria) => {
    if (SecurityAccessManager.ProductAvailabilityInquiry_IsAccessible()) {
      ReportService.inquireProductAvailabilityResults(
        criteria,
        this.loadProductAvailabilityPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadProductAvailabilityPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let atsInfosList = new Array();
      let availabilityInfoList = new Array();
      let purchaseProductAvailabilityList = new Array();
      let salesProductAvailabilityList = new Array();
      if (!isEmptyArray(response.data.resultBean.atsInfos)) {
        atsInfosList = response.data.resultBean.atsInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (!isEmptyArray(response.data.resultBean.availabilityinfos)) {
        availabilityInfoList = response.data.resultBean.availabilityinfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (
        !isEmptyArray(
          response.data.resultBean.purchaseProductAvailabilityDetails
        )
      ) {
        purchaseProductAvailabilityList =
          response.data.resultBean.purchaseProductAvailabilityDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (
        !isEmptyArray(response.data.resultBean.salesProductAvailabilityDetails)
      ) {
        salesProductAvailabilityList =
          response.data.resultBean.salesProductAvailabilityDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        availabilityInfoList: availabilityInfoList,
        atsInfosList: atsInfosList,
        purchaseProductAvailabilityList: purchaseProductAvailabilityList,
        salesProductAvailabilityList: salesProductAvailabilityList,
        isShowLookUp: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  generateProductAvailabilityReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ... ",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let productCriteria = new ProductAvailabilityCriteriaBean();
    productCriteria.companyCode = this.companyCode;
    productCriteria.fabricStyleCode = criteria.fabricStyleCode;
    productCriteria.fabricStyleColorCode = criteria.fabricStyleColorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new ProductAvailabilityDetailsRequest();
    listRequest.criteria = productCriteria;
    listRequest.input = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.ProductAvailabilityInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateProductAvailabilityDetailsReport(
          listRequest,
          this.generateProductAvailabilityPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.ProductAvailabilityInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateProductAvailabilityDetailsReport(
          listRequest,
          this.generateProductAvailabilityPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateProductAvailabilityPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new ProductAvailabilityCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      isShowLookUp: true,
      colorList: [],
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new ProductAvailabilityCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowLookUp: true,
      colorList: [],
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateProductAvailabilityReport(1);
  };
  generateExcel = () => {
    this.generateProductAvailabilityReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = " ";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        isShowColorLookup: false,
        colorList: [],
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.loadFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.loadFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  loadFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }
  loadFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.loadFabricStyleDetail(fabricStyleCode);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };

  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.loadFabricColourBySearchString(e.target.value);
    }
  };

  loadFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };

  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };

  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "Fabric#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleShortName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthSize", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Reserve Customer", "reserveCustomerCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Reserve CustomerName", "reserveCustomerName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Inventory#" : "RollSKU#", "rollSkuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Warehouse", "warehouseCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  purchaseListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "Fabric#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Reserve Customer", "reserveCustomerCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Reserve CustomerName", "reserveCustomerName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.O", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "orderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  salesListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "Fabric#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O", "salesOrderNumber", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cust P.O", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "salesOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;

  };
  atsInfoListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "Fabric#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VenOnOrderQty", "vendorOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustOnOrderQty", "customerOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;

  };
  render() {
    let availabilityInfoList = this.state.availabilityInfoList;
    let atsInfosList = this.state.atsInfosList;
    let purchaseProductAvailabilityList =
      this.state.purchaseProductAvailabilityList;
    let salesProductAvailabilityList = this.state.salesProductAvailabilityList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricLookupHandler={this.state.fabricLookupHandler}
          customerLookupHandler={this.state.customerLookupHandler}
          fabricCodeRef={this.fabricCodeRef}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
        />
        {this.state.isInquiryDatasFound && (
          <div>
            <Row>
              <Col>
                <FormLabel>Inventory Details</FormLabel>
              </Col>
              <Col>
                <FormLabel>Purchase Details</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <div className="div_Custom">
                  <div className="mt-3">
                    <CustomTable
                      data={availabilityInfoList}
                      columns={this.inquiryColumns()}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              </Col>
              <Col sm="6">
                <div className="div_Custom">
                  <div className="mt-3">
                    <CustomTable
                      data={purchaseProductAvailabilityList}
                      columns={this.purchaseListColumns()}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel>Sales Details</FormLabel>
              </Col>
              <Col>
                <FormLabel>ATS Details</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <div className="div_Custom">
                  <div className="mt-3">
                    <CustomTable
                      data={salesProductAvailabilityList}
                      columns={this.salesListColumns()}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              </Col>
              <Col sm="6">
                <div className="div_Custom">
                  <div className="mt-3">
                    <CustomTable
                      data={atsInfosList}
                      columns={this.atsInfoListColumns()}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  const fabricCodeRef = props.fabricCodeRef;
  let colorCodeRef = React.createRef();
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookUp}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="fabricStyleColorCode"
            placeholder="color"
            value={criteria.fabricStyleColorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={props.isDisableFields}
          />
        </Col>
      </Row>
    </div>
  );
}
function ProductAvailabilityInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <ProductAvailability {...props} name="" /> <br />
    </div>
  );
}
export default ProductAvailabilityInquiry;
